import React from 'react';
import { toastr } from 'react-redux-toastr';

/** Item de menu sem rota — exibe aviso no canto superior direito (toastr). */
export default function MenuItemSoon({ label, icon, message = 'Em breve' }) {
  return (
    <li>
      <a
        href="#"
        onClick={e => {
          e.preventDefault();
          toastr.info(message, label);
        }}
      >
        <i className={`fa fa-${icon}`} /> <span>{label}</span>
      </a>
    </li>
  );
}
